import classnames from 'classnames';

import styles from './TabButton.module.scss';

const PlusIcon = ({ className }: { className: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 3.33337V12.6667"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33398 8H12.6673"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const XIcon = ({ className }: { className: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 4L4 12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 4L12 12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export type TabButtonVariation = 'SELECTED' | 'UNSELECTED' | 'ADD';

export const TabButton = ({
  caption,
  variation = 'SELECTED',
  onClick,
  onRemoveButtonClick,
  showRemoveButton = false,
}: {
  caption: string;
  variation?: TabButtonVariation;
  onClick?: () => void;
  onRemoveButtonClick?: () => void;
  showRemoveButton?: boolean;
}) => {
  return (
    <div
      className={classnames(
        'd-flex ai-center jc-center br8 p-p',
        styles.tabButton,
        {
          [styles.selected]: variation === 'SELECTED',
          [styles.unselected]: variation === 'UNSELECTED',
          [styles.add]: variation === 'ADD',
          [styles.showRemoveButton]: showRemoveButton,
        }
      )}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onClick?.();
        }
      }}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      {variation === 'ADD' && <PlusIcon className={styles.plusIcon} />}
      {caption}
      {variation !== 'ADD' && showRemoveButton && (
        <button
          className={`ds-interactive-component d-flex ${styles.removeButton}`}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemoveButtonClick?.();
          }}
          onKeyDown={(e) => {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              onRemoveButtonClick?.();
            }
          }}
        >
          <XIcon className={styles.xIcon} />
        </button>
      )}
    </div>
  );
};
